import React from 'react'
import { Button } from 'components/UIElements'

const CreateDiaryButton = ({ hasClinro, studyLock, onClick }) => {
  return <Button content='Create Diary' disabled={studyLock} grey={hasClinro ? true : undefined} onClick={onClick} />
}

export default CreateDiaryButton
